import React, { useState, useEffect } from 'react'
import { motion } from 'framer-motion'
import logo from '../../assets/logo.png'
import { Link } from 'react-router-dom'
import { ThemeToggle } from '../ThemeToggle'

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <motion.nav
      initial={{ y: -100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: 'easeOut' }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background/80 backdrop-blur-md shadow-sm border-b border-border py-3'
          : 'bg-transparent py-5'
      }`}
    >
      <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8'>
        <div className='flex justify-between items-center'>
          {/* Logo */}
          <div className='flex items-center gap-2 cursor-pointer'>
            <img
              src={logo}
              alt='ClickVoltz Logo'
              className='h-8 w-auto object-contain rounded-lg'
            />
            <span className='font-bold text-xl tracking-tight text-foreground'>
              ClickVoltz
            </span>
          </div>

          {/* Desktop Navigation */}
          <div className='hidden md:flex items-center space-x-8'>
            {['Features', 'Solutions', 'Resources', 'Pricing'].map(item => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className='text-sm font-medium text-muted-foreground hover:text-foreground transition-colors'
              >
                {item}
              </a>
            ))}
          </div>

          {/* CTAs */}
          <div className='hidden md:flex items-center space-x-4'>
            <ThemeToggle />
            <Link
              to={'/login'}
              className='text-sm font-medium text-muted-foreground hover:text-primary transition-colors'
            >
              Login
            </Link>
            <button className='text-sm font-bold text-primary-foreground bg-primary hover:bg-primary/90 px-5 py-2.5 rounded-full transition-all duration-200 shadow-sm hover:shadow focus:outline-none'>
              Get demo
            </button>
          </div>

          {/* Mobile menu button */}
          <div className='md:hidden flex items-center'>
            <button className='text-slate-400 hover:text-white focus:outline-none'>
              <svg
                className='h-6 w-6'
                fill='none'
                viewBox='0 0 24 24'
                stroke='currentColor'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  strokeWidth={2}
                  d='M4 6h16M4 12h16M4 18h16'
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </motion.nav>
  )
}

export default Navbar
